import type { Feature } from '@luna/gatekeeper';

export const displayPin: Feature = {
    enabled: true,
    _description: 'Displays display pin card in the card services list',
};

export const displayPinEncryption: Feature = {
    enabled: true,
    _description: 'Enables new JWE secured info encryption',
};
